import React from "react";
import { motion } from "framer-motion";
import {
  FaHtml5,
  FaCss3Alt,
  FaReact,
  FaJava,
} from "react-icons/fa";
import { SiSpringboot, SiSelenium, SiCplusplus } from "react-icons/si";

const skills = [
  { name: "HTML", icon: <FaHtml5 size={22} /> },
  { name: "CSS", icon: <FaCss3Alt size={22} /> },
  { name: "React JS", icon: <FaReact size={22} /> },
  { name: "Spring Boot", icon: <SiSpringboot size={22} /> },
  { name: "Basic Java", icon: <FaJava size={22} /> },
  { name: "C++", icon: <SiCplusplus size={22} /> },
  { name: "Selenium", icon: <SiSelenium size={22} /> },
];

export default function Skills() {
  return (
    <section className="max-w-4xl mx-auto px-6 pb-20">
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-xl font-bold text-black dark:text-white mb-5"
      >
        Skills
      </motion.h2>

      {/* Glass card */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="relative max-w-4xl overflow-hidden rounded-3xl border border-black/10 dark:border-white/10 
        bg-white/60 dark:bg-white/5 backdrop-blur-xl
        shadow-[0_10px_30px_rgba(0,0,0,0.10)] dark:shadow-[0_10px_30px_rgba(0,0,0,0.45)]"
      >
        {/* lighting glow */}
        <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-purple-500/15 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-sky-500/15 blur-3xl" />

        <div className="relative p-6">
          <div className="flex flex-wrap gap-3">
            {skills.map((skill, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.35, delay: idx * 0.03 }}
                viewport={{ once: true }}
                className="group flex items-center gap-2 rounded-2xl px-4 py-2
                border border-black/10 dark:border-white/10
                bg-white/70 dark:bg-white/5 backdrop-blur
                hover:border-black/20 dark:hover:border-white/20
                hover:shadow-md transition"
              >
                <span className="text-black/70 dark:text-white/70 group-hover:text-black dark:group-hover:text-white transition">
                  {skill.icon}
                </span>

                <span className="text-[14px] md:text-[15px] font-medium text-black/70 dark:text-white/70 group-hover:text-black dark:group-hover:text-white transition">
                  {skill.name}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
}
